export function FormatDecimalNumber(x) {
    return x.toLocaleString();
}

export function ParseDecimalNumber(str) {
    return Number.parseFloat(str.replace(",", "."));
}

export function FormatFullPercent(decimal) {
    return FormatDecimalNumber(Math.round(decimal * 100)) + '%';
}

export function ParseFullPercent(str) {
    return ParseDecimalNumber(str.replace('%', '')) / 100;
}
